import type { DemandThreshold } from "../types/heatmap"

// Relative thresholds based on pattern weights (0-7 scale)
export const DEMAND_THRESHOLDS: DemandThreshold[] = [
  { level: "low", min: 0, max: 2, labelKey: "heatmap.legend.low" },
  { level: "medium", min: 2, max: 4, labelKey: "heatmap.legend.medium" },
  { level: "high", min: 4, max: 6, labelKey: "heatmap.legend.high" },
  { level: "peak", min: 6, max: Infinity, labelKey: "heatmap.legend.peak" },
]

export const DAY_LABEL_KEYS = [
  "form.fields.distribution.monday",
  "form.fields.distribution.tuesday",
  "form.fields.distribution.wednesday",
  "form.fields.distribution.thursday",
  "form.fields.distribution.friday",
  "form.fields.distribution.saturday",
  "form.fields.distribution.sunday",
]
